import { ShieldCheck, Clock3, Cpu, Crosshair, BadgeCheck } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";

const Card = ({ className = "", children, testId, delay = 0 }) => (
  <Reveal delay={delay} className={className}>
    <div data-testid={testId} className="group relative h-full border border-white/10 bg-[#0D0D10] p-7 sm:p-8 overflow-hidden transition-colors duration-500 hover:border-red-600/50">
      <div className="pointer-events-none absolute -right-20 -top-20 h-48 w-48 rounded-full bg-red-700/0 blur-3xl transition-colors duration-700 group-hover:bg-red-700/25" />
      <div className="relative h-full flex flex-col">{children}</div>
    </div>
  </Reveal>
);

const Small = ({ icon: Icon, data, big }) => (
  <>
    <Icon className="h-6 w-6 text-red-500" strokeWidth={1.5} />
    {big && <p className="mt-6 font-display font-black text-6xl text-white leading-none">{big}</p>}
    <h3 className="mt-auto pt-6 font-display font-bold uppercase text-2xl text-white">{data[0]}</h3>
    <p className="mt-2 text-sm text-zinc-300 leading-relaxed">{data[1]}</p>
  </>
);

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" data-testid="about-section" className="relative py-28 lg:py-40 bg-[#08080A]">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal><Eyebrow>{a.eyebrow}</Eyebrow><SectionTitle className="mt-6 max-w-3xl">{a.title}</SectionTitle></Reveal>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-6 lg:auto-rows-[minmax(240px,auto)] gap-4">
          <Card testId="igpr-license-card" className="md:col-span-6 lg:col-span-4 lg:row-span-2">
            <div className="absolute inset-0 -m-8 bg-cover bg-center opacity-[0.12] grayscale" style={{ backgroundImage: "url(/img/industrial.jpg)" }} />
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center border border-red-600/60 bg-red-950/40"><ShieldCheck className="h-6 w-6 text-red-500" strokeWidth={1.5} /></span>
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-red-400" data-testid="igpr-license-badge">{a.licTitle} · L. 333/2003</span>
            </div>
            <p className="relative mt-10 font-display font-bold text-2xl sm:text-3xl text-white leading-tight max-w-2xl">{a.lead}</p>
            <p className="relative mt-6 text-zinc-300 leading-relaxed max-w-2xl">{a.body}</p>
          </Card>
          <Card testId="about-card-support" className="md:col-span-3 lg:col-span-2" delay={0.08}><Small icon={Clock3} data={a.cards.support} big="24/7" /></Card>
          <Card testId="about-card-pro" className="md:col-span-3 lg:col-span-2" delay={0.16}><Small icon={BadgeCheck} data={a.cards.pro} big="100%" /></Card>
          <Card testId="about-card-tech" className="md:col-span-3" delay={0.08}><Small icon={Cpu} data={a.cards.tech} /></Card>
          <Card testId="about-card-nocompromise" className="md:col-span-3 !bg-transparent" delay={0.16}>
            <div className="absolute inset-0 -m-8 bg-[linear-gradient(135deg,#7f1d1d_0%,#2a0707_55%,#0D0D10_100%)]" />
            <Small icon={Crosshair} data={a.cards.nocomp} />
          </Card>
        </div>
      </div>
    </section>
  );
};
